import cookiesService from "@/services/cookiesService";
import { USER_ROLE_GROUP } from "@/utils/constants";

export async function isAdmin() {
  try {
    const user = await cookiesService.getCookie("authToken");

    if (!user) {
      throw new Error("user not found");
    }

    return user.user_group_id === USER_ROLE_GROUP.Admin;
  } catch (error) {
    console.error(error);
    alert("Something went wrong. Please try again later.");

    return false;
  }
}

export async function isTrainer() {
  try {
    const user = await cookiesService.getCookie("authToken");

    if (!user) {
      throw new Error("user not found");
    }

    return (
      user.user_group_id === USER_ROLE_GROUP.Trainer ||
      user.user_group_id === USER_ROLE_GROUP.Admin
    );
  } catch (error) {
    console.error(error);
    return false;
  }
}

// New middleware function to check if user is already authenticated
export async function isAuthenticated() {
  try {
    const authToken = await cookiesService.getCookie("authToken");
    return !!authToken; // Returns true if token exists, false otherwise
  } catch (error) {
    console.error("Error checking authentication:", error);
    return false;
  }
}
